import React from 'react';
import Card from '@mui/material/Card';
import DollarIcon from '@mui/icons-material/AttachMoney';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import { translate } from 'react-admin';

import CardIcon from './CardIcon';

const useStyles = makeStyles({
    main: {
        flex: '1',
        marginRight: '1em',
        marginTop: 20,
        width: '450px',
    },
    card: {
        overflow: 'inherit',
        textAlign: 'right',
        padding: 16,
        minHeight: 52,
    },
});

const MonthlyRevenue = ({ value }) => {
    const classes = useStyles();

    return  <div className={classes.main}>
                <CardIcon Icon={DollarIcon} bgColor="#31708f" />
                <Card className={classes.card}>
                    <Typography className={classes.title} color="textSecondary">
                        Monthly Revenue
                    </Typography>
                    <Typography variant="headline" component="h2">
                        {value}
                    </Typography>
                </Card>
            </div>
};

// const enhance = compose(
//     withStyles(styles),
//     translate
// );

export default MonthlyRevenue;
